module.exports = __webpack_public_path__ + "img/pålestikk1.ef99ca6e.jpg";